import { Box, Grid } from "@mui/material";
import CheckboxWithTooltip from "../../../components/ui/CheckboxWithTooltip";
import CustomCheckbox from "../../../components/ui/CustomCheckbox";

export const AuctionTypeCard = ({
  type,
  title,
  tooltipText,
  timedLabel,
  buyNowLabel,
  formik,
  disabled,
}) => {
  const isLocal = type === "local";
  const timedField = isLocal ? "localAuctionTimed" : "exportAuctionTimed";
  const buyNowField = isLocal ? "localAuctionBuyNow" : "exportAuctionBuyNow";
  const auctionField = isLocal ? "localAuction" : "exportAuction";
  const oppositeAuctionField = isLocal ? "exportAuction" : "localAuction";

  const handleAuctionTypeChange = () => {
    const newValue = !formik.values[auctionField];
    const currentPrefix = isLocal ? "local" : "export";
    const oppositePrefix = isLocal ? "export" : "local";

    // Reset current type's fields if toggling off
    if (!newValue) {
      formik.setFieldValue(`${currentPrefix}AuctionTimed`, false);
      formik.setFieldValue(`${currentPrefix}AuctionBuyNow`, false);
      formik.setFieldValue(`${currentPrefix}AuctionDate`, "");
      formik.setFieldValue(`${currentPrefix}AuctionTime`, "");
      formik.setFieldValue(`${currentPrefix}BuyNowDate`, "");
      formik.setFieldValue(`${currentPrefix}BuyNowTime`, "");
    }

    formik.setFieldValue(auctionField, newValue);
    formik.setFieldValue(`${currentPrefix}AuctionTimed`, true);

    // If we're selecting this type, deselect the opposite type
    if (newValue) {
      formik.setFieldValue(oppositeAuctionField, false);

      // Reset the opposite type's fields
      formik.setFieldValue(`${oppositePrefix}AuctionTimed`, false);
      formik.setFieldValue(`${oppositePrefix}AuctionBuyNow`, false);
      formik.setFieldValue(`${oppositePrefix}AuctionDate`, "");
      formik.setFieldValue(`${oppositePrefix}AuctionTime`, "");
      formik.setFieldValue(`${oppositePrefix}BuyNowDate`, "");
      formik.setFieldValue(`${oppositePrefix}BuyNowTime`, "");
    }
  };

  return (
    <Grid
      item
      size={{ xs: 12, lg: 6 }}
      border={"2px dashed #E0E0E0"}
      borderColor={
        formik.values[auctionField] ? "border.main" : "border.disabled"
      }
      borderRadius={4}
      px={1}
      py={1.5}
    >
      <CheckboxWithTooltip
        onClick={handleAuctionTypeChange}
        label={title}
        tooltipText={tooltipText}
        selected={formik.values[auctionField]}
        disabled={disabled}
      />
      <Box display={"flex"} gap={2} mt={2} px={1}>
        <CustomCheckbox
          label={timedLabel}
          selected={formik.values[timedField]}
          onClick={() =>
            formik.setFieldValue(timedField, !formik.values[timedField])
          }
          disabled={!formik.values[auctionField]}
        />
        <CustomCheckbox
          label={buyNowLabel}
          selected={formik.values[buyNowField]}
          onClick={() =>
            formik.setFieldValue(buyNowField, !formik.values[buyNowField])
          }
          disabled={!formik.values[auctionField]}
        />
      </Box>
    </Grid>
  );
};
